import { render, staticRenderFns } from "./PageAssetHome.vue?vue&type=template&id=2f0c9c74&scoped=true"
import script from "./PageAssetHome.vue?vue&type=script&lang=js"
export * from "./PageAssetHome.vue?vue&type=script&lang=js"
import style0 from "./PageAssetHome.vue?vue&type=style&index=0&id=2f0c9c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c9c74",
  null
  
)

export default component.exports